import { ColumnMap } from 'src/app/domainObjects/columnMap';

export class ColumnMapDefinition {
    id?: number;
    sourceColumn: string;
    targetColumn?: string;
    dataType?: string = null;
    pyDataType?: string = null;

    constructor(id: number, sourceCol: string, targetCol: string, dataType: string, pyDataType: string) {
      this.id = id;
      this.sourceColumn = sourceCol;
      this.targetColumn = targetCol;
      this.dataType = dataType;
      this.pyDataType = pyDataType;
    }

    static fromJSON(data: any): ColumnMapDefinition {
      //console.log(`fromJson invoked: ${data}`);
      const instance: ColumnMapDefinition = Object.assign(new ColumnMapDefinition(0, '', '', '', ''), data);
      return instance;
    }

    toColumnMap(): ColumnMap {
      return new ColumnMap(this.sourceColumn, this.targetColumn, this.dataType, this.pyDataType);
    }
}
